import {Tool} from "./Tool";
import {SelectTool} from "./SelectTool";

const State = {
	START: 1,
	END: 0
};

export class ConnectTool extends Tool {

	constructor() {
		super();
		this.state = State.START;
		this.lastFound = null;
		this.draggingFrom = null;
		this.lastPos = null;
	}

	getCursor() {
		return "default";
	}

	drawAfterModel(ctx, pixelWidth) {
		if (this.draggingFrom !== null && this.lastPos !== null) {
			ctx.save();
			ctx.lineWidth = 2;
			let canConnect = this.canConnect();
			ctx.strokeStyle = canConnect ? S.HI_COLORS[8] : "#666666";
			if (canConnect) ctx.setLineDash([6, 2]);
			else ctx.setLineDash([4, 4]);
			ctx.beginPath();
			ctx.moveTo(this.draggingFrom.x, this.draggingFrom.y);
			ctx.lineTo(this.lastPos.x, this.lastPos.y);
			ctx.stroke();
			ctx.restore();
		}
	}

	/**
	 * @param {MouseEvent} e
	 * @param {ProcessCanvas} canvas
	 */
	mouseDown(e, canvas) {
		this.down = true;
		if (this.lastFound != null) {
			this.draggingFrom = this.lastFound;
			this.state = State.END;
			return true;
		}
		return false;
	}

	mouseUp(e, canvas) {
		if (this.canConnect()) {
			this.draggingFrom.connectTo(this.lastFound);
		}
		let changed = this.draggingFrom !== null;
		this.draggingFrom = null;
		return changed;
	}

	/**
	 * @param {ProcessCanvas} canvas
	 */
	mouseMove(e, canvas) {
		this.lastPos = Tool.normalizeEvent(e, canvas);
		const objs = this.draggingFrom == null ? canvas.getConnectFromManipulables() : canvas.getConnectToManipulables(this.draggingFrom);
		let found = SelectTool.findHit(objs, this.lastPos.x, this.lastPos.y);
		for (let o of objs) {
			o.hovered = (o === found);
		}
		const change = (found === this.lastFound);
		this.lastFound = found;
		return change || this.draggingFrom !== null;
	}

	canConnect() {
		return this.draggingFrom !== null
			&& this.lastFound !== null
			&& this.draggingFrom !== this.lastFound;
	}
}